import { Component } from '@angular/core';
import { TenantIds } from '../../../enums/tenants.enum';

@Component({
  selector: 'app-chatbot',
  templateUrl: './chatbot.component.html',
  styleUrls: ['./chatbot.component.scss']
})
export class ChatbotComponent {
  isOpen = false;
  TenantIds = TenantIds;

  toggleDrawer() {
    this.isOpen = !this.isOpen;
  }
}
